var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrlaubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Urlaub Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Urlaub-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(16.000000, 15.000000)",
    stroke: "#263238",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.998,31.9998 L4.002,31.9998 C1.791,31.9998 0,30.2088 0,27.9978 L0,10.0018 C0,7.7918 1.791,5.9998 4.002,5.9998 L27.998,5.9998 C30.208,5.9998 32,7.7918 32,10.0018 L32,27.9978 C32,30.2088 30.208,31.9998 27.998,31.9998 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5.9998,
    x2: 7,
    y2: 31.7938,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.0024,
    y1: 6.2064,
    x2: 25.0024,
    y2: 31.9994,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8457,-0.0002 L10.8487,-0.0002 C9.7437,-0.0002 8.8477,0.8958 8.8477,2.0018 L8.8477,5.9998 L22.8477,5.9998 L22.8477,2.0018 C22.8477,0.8958 21.9507,-0.0002 20.8457,-0.0002 Z",
    id: "Stroke-7",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlaubIcon);
export default __webpack_public_path__ + "static/media/urlaub-icon.ba94f2cc.svg";
export { ForwardRef as ReactComponent };